import { Routes } from '@angular/router';
import { isAuthenticatedGuard } from '@shared/guards/is-authenticated.guard';
import { isGreenlandUserGuard } from '@shared/guards/is-greenland-user.guard';
import { OrganizationRouteNames, RouteNames } from './route-names';
import { DocumentLayoutComponent } from './core/layouts/document-layout/document-layout.component';
import { MainLayoutComponent } from './core/layouts/main-layout/main-layout.component';
import { MainPageComponent } from './core/pages/main-page/main-page.component';
import { UserLoginComponent } from './modules/user/pages/user-login/user-login.component';
import { UserRegisterComponent } from './modules/user/pages/user-register/user-register.component';
import { UserResetPasswordComponent } from './modules/user/pages/user-reset-password/user-reset-password.component';
import { ForbiddenPageComponent } from './core/pages/forbidden-page/forbidden-page.component';
import { PRE_ORDER_ROUTE } from './modules/pre-order/routes';
import { CARGO_LOADING_ROUTE } from './modules/cargo-loading/routes';
import { CARGO_ON_THE_WAY_ROUTE } from './modules/cargo-calculation/routes';
import { HomeComponent } from './modules/home/home.component';
import { SPECIFICATION_ROUTE } from './modules/invoices/routes';

export const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: RouteNames.MAIN_PAGE,
        component: MainPageComponent,
        title: 'Главная страница',
      },
      {
        path: RouteNames.LOGIN_PAGE,
        component: UserLoginComponent,
        title: 'Войти',
      },
      {
        path: RouteNames.REGISTER_PAGE,
        component: UserRegisterComponent,
        title: 'Регистрация',
        // canActivate: [uniqueKeyGuard],
      },
      {
        path: RouteNames.RESET_PASSWORD_PAGE,
        component: UserResetPasswordComponent,
        title: 'Восстановление пароля',
      },
      {
        path: RouteNames.HOME,
        title: 'Домашняя страница',
        canActivate: [isAuthenticatedGuard],
        component: HomeComponent,
      },
      {
        path: RouteNames.KANBAN_PAGE,
        title: 'Канбан',
        canActivate: [isAuthenticatedGuard],
        loadChildren: () =>
          import('./modules/kanban/routes').then(mod => mod.KANBAN_ROUTES),
      },
      {
        path: RouteNames.JOURNAL_PAGE,
        title: 'Журнал',
        canActivate: [isAuthenticatedGuard],
        loadChildren: () =>
          import('./modules/journal/routes').then(mod => mod.JOURNAL_ROUTES),
      },
      {
        path: RouteNames.USER,
        title: 'Учетная запись',
        loadComponent: () =>
          import('./modules/user/pages/user-edit/user-edit.component').then(
            c => c.UserEditComponent,
          ),
        canActivate: [isAuthenticatedGuard],
      },
      {
        path: OrganizationRouteNames.MAIN,
        title: 'Организация',
        canActivate: [isAuthenticatedGuard],
        loadChildren: () =>
          import('./modules/organization/routes').then(
            mod => mod.ORGANIZATION_ROUTES,
          ),
      },
      {
        path: RouteNames.CATALOGS_PAGE,
        title: 'Каталоги',
        canActivate: [isAuthenticatedGuard],
        loadChildren: () =>
          import('./modules/catalogs/routes').then(mod => mod.CATALOGS_ROUTES),
      },
      {
        path: RouteNames.TOOLS,
        title: 'Инструменты',
        canActivate: [isAuthenticatedGuard],
        loadChildren: () =>
          import('./modules/tools/routes').then(mod => mod.TOOLS_ROUTES),
      },
      {
        path: RouteNames.REPORTS,
        title: 'Отчеты',
        canActivate: [isAuthenticatedGuard, isGreenlandUserGuard],
        loadChildren: () =>
          import('./modules/reports/routes').then(mod => mod.REPORTS_ROUTES),
      },
      {
        path: RouteNames.INVOICES_PAGE,
        title: 'Инвойсы',
        canActivate: [isAuthenticatedGuard],
        loadChildren: () =>
          import('./modules/invoices/routes').then(
            mod => mod.INVOICES_JOURNAL_ROUTES,
          ),
      },
      {
        path: RouteNames.FORBIDDEN_PAGE,
        title: 'Доступ запрещен',
        component: ForbiddenPageComponent,
      },
    ],
  },
  {
    path: '',
    component: DocumentLayoutComponent,
    children: [
      PRE_ORDER_ROUTE,
      CARGO_ON_THE_WAY_ROUTE,
      CARGO_LOADING_ROUTE,
      SPECIFICATION_ROUTE,
    ],
  },
  {
    path: '**',
    redirectTo: RouteNames.HOME,
  },
];
